export const GET_COUNT_DOWN = "GET_COUNT_DOWN";
export const GET_COUNTY = "GET_COUNTY";
export const GET_USD_PRICE = "GET_USD_PRICE";
export const GET_BG_IMAGE = "GET_BG_IMAGE";
